$(window).on('load', function() {
    $('body').css('opacity', '0').animate({ opacity: 1 }, 1000); // Adjust 1000 for fade duration in milliseconds
});

$(document).ready(function () {
  

  $('.pagespecial-open').on('click', function(e) {
    e.preventDefault();
    
    // Get the href of the clicked menu item
    var pageUrl = $(this).data('link');
    console.log(pageUrl);

    // Load the content of the selected page into the content container
    $('.pagespecial').load(pageUrl + ' #content', function(response, status, xhr) {
      if (status == "error") {
        console.log("Error loading content: " + xhr.status + " " + xhr.statusText);
      } else {
        // Add a class to indicate that the content is now open
        $('.pagespecial').addClass('open');
      }
    });
  });

  $('.product-images img').click(function(){
    let ref = $(this).attr('src')
    console.log(ref)
    $('.product-main img').attr('src', ref)
  })

  $('.custom-dropdown').click(function(){
    $('.dropdown-options').toggle();
    $('.selected-variant img').toggleClass('reverse');
  })
  
  $(document).click(function(event) {
    if (!$(event.target).closest('.custom-dropdown').length) {
      $('.dropdown-options').hide();
      $('.selected-variant img').removeClass('reverse');
    }
  });

  $('.dropdown-option.stock').on('click', function () {
      const variantId = $(this).data('variant-id');
      const variantTitle = $(this).text();
      $('#addToCartForm input[name="id"]').val(variantId);
      $('#selectedVariant span').text(variantTitle);
      $('#addToCartButton').show().prop("disabled", false);
      $('.klaviyo-bis-trigger').removeClass('on').hide().attr('data-variant-id', variantId);
  });

  $('.dropdown-option.no-stock').on('click', function () {
      const variantId = $(this).data('variant-id');
      const variantTitle = $(this).text();
      $('#selectedVariant span').text(variantTitle);
      $('#addToCartButton').hide();
      $('.klaviyo-bis-trigger').addClass('on').show().attr('data-variant-id', variantId);
      console.log(variantId)
  });
  
  $('.product-slider').slick({
      dots: true,
      arrows: false
  });

  $('.product-card-slider').slick({
      dots: false,
      arrows: true,
      prevArrow: `<button type="button" class="slick-prev"><img src="//thejude.com/cdn/shop/t/10/assets/arrownew.png?v=51826720886442163991780753332" alt=""></button>`,
      nextArrow: `<button type="button" class="slick-next"><img src="//thejude.com/cdn/shop/t/10/assets/arrownew.png?v=51826720886442163991780753332" alt=""></button>`,
      infinite: false,
      responsive: [
          {
              breakpoint: 769,
              settings: {
                  dots: true,
                  arrows: false
              }
          }
      ]
  });

  // $('.product-images').slick({
  //   dots: true,
  //   prevArrow: '<button type="button" class="slick-prev"><</button>',
  //   nextArrow: '<button type="button" class="slick-next">></button>'
  // });

  $('.cart-button, .cart-close, .cart-overlay, .header-cart').click(function(){
    $('.cart').fadeToggle();
    if ($('.menu-mobile').is(':visible')) {
      $('.menu-mobile').hide();
      $('.menu-mobile-search').hide();
      $('.header-cart, .header-search-open').toggle();
      $('.header-menu-toggle').toggle();
    }
  })

  $('.toggle-more-info').click(function() {
    let num = $(this).data('info')
    $('.product-info-more[data-info=' + num + ']').toggle();
  })

  $('.size-guide-open').click(function(){
    $('.size-guide').show();
    $('.product-info').css('position', 'static')
  })

  $('.size-guide-close, .size-guide-overlay').click(function(){
    $('.size-guide').hide();
    $('.product-info').css('position', 'sticky')
  })

  $('.header-menu-toggle').click(function(){
    window.scrollTo(0, 0);
    $('.header-cart, .header-search-open').toggle();
    $('.header-menu-toggle').toggle();
    if ($('.menu-mobile-search').is(':visible')) {
      // The div is visible
      $('.menu-mobile').hide();
    } else {
      // The div is not visible
      $('.menu-mobile').show();
    }
    $('.menu-mobile-search').toggle();
  })  

  $('.header-search-open').click(function(){
    $('.header-menu-toggle').toggle();    
    $('.header-cart, .header-search-open').toggle();
    $('.menu-mobile-search').toggle();
  })  

  $('.shop-toggler').click(function(){
    $('.shop-toggled').toggle();
  })

// Function to format prices as money using Shopify's formatMoney function if available
function formatMoney(amount) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(amount, Shopify.money_format);
  } else {
    // Fallback formatting if Shopify.formatMoney is not available
    return (amount / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: Shopify.currency.active // Assuming Shopify.currency.active holds the active currency code
    });
  }
}

// Function to update the cart item count
function updateCartItemCount() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    cache: false, // Disable caching
    success: function(cart) {
      updateCartTotals(cart);
      $('#cart-count').text(cart.item_count);
      $('#cart-count-top').text(cart.item_count);
    }
  });
}

// Function to update the individual item total
function updateItemTotal(variantId, quantity, price) {
  var itemTotalPrice = quantity * price;
  $(`.cart-item-total[data-variant-id="${variantId}"]`).text(formatMoney(itemTotalPrice)); // Assuming prices are in cents
}

// Function to update the cart totals
function updateCartTotals(cart) {
  const total = formatMoney(cart.total_price); // Assuming prices are in cents
  $('.cart-footer-top strong').text(`TOTAL: ${total}`);
  $('.cart-footer-top span:last-child').text(total);
}

$('#addToCartButton').click(function () {
  // Get form data
  const formData = $('#addToCartForm').serialize();

  // Use Shopify's AJAX API to add the variant to the cart
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    cache: false, // Disable caching
    dataType: 'json',
    success: function (response) {
      console.log('Item added to cart:', response);

      // Fetch the updated cart content using Shopify's AJAX API
      $.ajax({
        type: 'GET',
        url: '/cart',
        dataType: 'html',
        success: function (cartContent) {
          const extractedContent = $(cartContent).find('#cart-container').html();
          // Update the sidebar cart with the new content
          $('#sidebar-cart').html(extractedContent);
          $('.cart').fadeIn();
          // Update cart item count
          updateCartItemCount();
        }
      });
    }
  });
});

$('.quantity-button').click(function () {
  // Get the variant ID and action from the data attributes
  const variantId = $(this).data('variant-id');
  const action = $(this).data('action');
  
  // Determine the quantity adjustment based on the action
  const quantityAdjustment = action === 'increment' ? 1 : -1;

  // Use Shopify's AJAX API to get the current cart state
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    cache: false, // Disable caching
    success: function (cart) {
      // Find the current quantity of the item
      const currentItem = cart.items.find(item => item.id === variantId);

      // Calculate the new quantity
      const newQuantity = currentItem.quantity + quantityAdjustment;

      // Use Shopify's AJAX API to update the cart
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: {
            [variantId]: newQuantity,
          },
        },
        dataType: 'json',
        success: function (updatedCart) {
          // Update the quantity display
          const updatedItem = updatedCart.items.find(item => item.id === variantId);
          $(`.quantity-display[data-variant-id="${variantId}"]`).text(updatedItem.quantity);
          // Update cart item count
          updateCartItemCount();
          // Update the individual item total
          updateItemTotal(variantId, updatedItem.quantity, updatedItem.final_price);
        }
      });
    }
  });
});

// Click event for remove buttons
$('#sidebar-cart').on('click', '.remove-button', function () {
  const variantId = $(this).data('variant-id');

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: {
      updates: {
        [variantId]: 0, // Set quantity to 0 to remove the item
      },
    },
    cache: false,
    dataType: 'json',
    success: function (updatedCart) {
      $(`.cart-item[data-variant-id="${variantId}"]`).remove();
      updateCartItemCount();
    },
    error: function (error) {
      console.error('Error removing item:', error);
    }
  });
});

// Change event for size select dropdown
$('#sidebar-cart').on('change', '.size-select', function () {
  const lineItemKey = $(this).data('line-item-key');
  const currentVariantId = $(this).data('current-variant-id');
  const newVariantId = $(this).val();
  const quantity = $(this).data('quantity');

  if (newVariantId == currentVariantId) return;

  // Remove the old variant and add the new one
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      id: lineItemKey,
      quantity: 0
    },
    cache: false,
    dataType: 'json',
    success: function () {
      // Add the new variant with the same quantity
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: newVariantId,
          quantity: quantity
        },
        cache: false,
        dataType: 'json',
        success: function () {
          // Refresh the cart content
          $.ajax({
            type: 'GET',
            url: '/cart',
            dataType: 'html',
            success: function (cartContent) {
              const extractedContent = $(cartContent).find('#cart-container').html();
              $('#sidebar-cart').html(extractedContent);
              updateCartItemCount();
            }
          });
        },
        error: function (error) {
          console.error('Error adding new variant:', error);
        }
      });
    },
    error: function (error) {
      console.error('Error removing old variant:', error);
    }
  });
});

// Initial update of the cart item count on page load
$(document).ready(function() {
  updateCartItemCount();
});

$('#newsletter-form').on('submit', function(event) {
    if (!$('#privacy-policy').is(':checked')) {
        alert('You must agree to the Privacy Policy to subscribe.');
        event.preventDefault(); // Prevent form submission
    }
});
  

  $('#privacy_policy, #confirm_age').on('change', function() {
    updateSubmitButtonState();
  });

  function updateSubmitButtonState() {
    const privacyPolicyChecked = $('#privacy_policy').prop('checked');
    const confirmAgeChecked = $('#confirm_age').prop('checked');
    $('#submit_button').prop('disabled', !privacyPolicyChecked || !confirmAgeChecked);
  }


  function addNewAddress() {
    var formData = $('#new-address-form').serialize();
    
    $.ajax({
      type: 'POST',
      url: '/account/addresses', // Update the endpoint based on your requirements
      data: formData,
      success: function(response) {
        // Handle the success response, e.g., display a message or update the UI
        console.log('Address added successfully');
      },
      error: function(error) {
        // Handle the error response
        console.error('Error adding address:', error);
      }
    });
  }

      // Tab functionality
    $('.tab-link').on('click', function(e) {
        e.preventDefault();
        
        var target = $(this).attr('href');
        var escapedTarget = CSS.escape(target);

        $('.tab-link').removeClass('active');
        $(this).addClass('active');
        $('.account-navigation li a[href=' + escapedTarget  + ']').addClass('active')

        $('.tab-content').removeClass('active');
        $(target).addClass('active');
    });

    // Load more products when reaching the bottom

  $(window).scroll(function () {

  });

});


// $(document).ready(function() {
//   $('.image-container a').each(function() {
//     var a = $(this);
//     var img = $(this).find('img');

//     // Create a temporary image to determine the natural dimensions
//     var tempImg = new Image();
//     tempImg.src = img.attr('src');

//     tempImg.onload = function() {
//       if (tempImg.width > tempImg.height) {
//         a.addClass('landscape');
//       } else {
//         a.addClass('portrait');
//       }
//     };
//   });
// });


//////// REcently viewed

$(document).ready(function () {
  
    // Check if we're on a product page
    if ($('.product-page').length) {
        // Extract data from the DOM
        const currentProduct = {
            url: window.location.href, // Current page URL
            image: $('.product-main img').first().attr('src'), // First product image
            title: $('.product-info-title h1').text().trim(), // Product title
            price: $('.product-info-title').find('br').next().text().trim() // Product price after <br>
        };

        // Retrieve the existing recently viewed products from localStorage
        let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

        // Check if the list is empty or contains only the currently viewed product
        if (
            recentlyViewed.length === 0 || 
            (recentlyViewed.length === 1 && recentlyViewed[0].title === currentProduct.title)
        ) {
            $('.product-recently-viewed').hide();
        } else {
            $('.product-recently-viewed').show(); // Optional, in case it needs to be re-shown
        }

        // Check if the product is already in the list by title
        if (!recentlyViewed.some(product => product.title === currentProduct.title)) {
            recentlyViewed.unshift(currentProduct); // Add the new product at the start
            recentlyViewed = recentlyViewed.slice(0, 5); // Limit to 5 products saved in localStorage
            localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed)); // Save back to localStorage
        }

    }


    // Load "Recently Viewed" products into the section
    const $recentlyViewedContainer = $('.product-recently-viewed-list');
    if ($recentlyViewedContainer.length) {
        let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

        recentlyViewed
            .filter(product => product.url !== window.location.href) // Exclude the current product
            .slice(0, 4) // Limit to 4 products displayed
            .forEach(function (product) {
                const productHTML = `
                    <div class="product-related-item product-recently-viewed-item">
                        <a href="${product.url}">
                            <img src="${product.image}" alt="${product.title}">
                            <p>${product.title}</p>
                        </a>
                    </div>
                `;
                $recentlyViewedContainer.append(productHTML);
            });
    }  


    // banner

    var bannerSelector = '.banner'; // Your banner class selector

    // Check if the banner has been hidden before
    if (sessionStorage.getItem('bannerClosed') === 'true') {
        $(bannerSelector).hide();
    }

    // Hide the banner and set session storage on "close" click
    $('.banner-close').on('click', function () {
        $(bannerSelector).fadeOut(); // Hide the banner with animation
        sessionStorage.setItem('bannerClosed', 'true'); // Remember the banner is closed
    });


});


// CURRENCY

const currencySelectors = document.querySelectorAll('#currency-select');

if (currencySelectors.length > 0) {
  currencySelectors.forEach(selector => {
    selector.addEventListener('change', function() {
      const selectedOption = this.options[this.selectedIndex];
      const url = selectedOption.getAttribute('data-url');
      if (url) {
        window.location.href = url;
      }
    });
  })
}


// URL metafields aren't filtered by Shopify Markets, so verify swatch targets
// against the current locale/market before displaying them.
const marketProductChecks = new Map();

function checkMarketProduct(handle) {
    if (!marketProductChecks.has(handle)) {
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const request = fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
            .then(response => response.ok)
            .catch(() => false);

        marketProductChecks.set(handle, request);
    }

    return marketProductChecks.get(handle);
}

function validateMarketSwatches(scope) {
    const swatches = [];

    if (scope.matches && scope.matches('[data-market-product-handle]')) {
        swatches.push(scope);
    }
    if (scope.querySelectorAll) {
        swatches.push(...scope.querySelectorAll('[data-market-product-handle]'));
    }

    swatches.forEach(swatch => {
        if (swatch.dataset.marketProductChecked) return;

        swatch.dataset.marketProductChecked = 'true';
        checkMarketProduct(swatch.dataset.marketProductHandle).then(exists => {
            if (exists) {
                swatch.style.removeProperty('display');
            } else {
                swatch.remove();
            }
        });
    });
}

validateMarketSwatches(document);

new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                validateMarketSwatches(node);
            }
        });
    });
}).observe(document.body, { childList: true, subtree: true });


